export default __webpack_public_path__ + "static/media/menuCompartilhar.b57a3d08.svg";